<div class="flex w-full">
    <app-vertical-menu [burgerMenu]="true" (navigateToRoute)="navigateToRoute.emit($event)"> </app-vertical-menu>
</div>
